export default __webpack_public_path__ + "static/intro-w-moto-short-f8843f5d663b08f9b175ecc1fe7d2459.svg";